export default __webpack_public_path__ + "static/media/about.46cbba0b.jpg";